import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "@tsp-core/store/utils";

import { OwnWorkTypeAndSubTypeRecord, WorkSubTypeUuid, WorkTypeId } from "../types";
import { parseWorkSubTypeUuid, parseWorkTypeId } from "../utils";

type GetOwnWorkTypeAndSubTypeFilterValuesResponseData = {
  workSubTypes: Array<{
    workTypeId: WorkTypeId;
    workSubTypeUuid: WorkSubTypeUuid;
  }>;
};

export const ownWorkTypeAndSubTypeApi = createApi({
  reducerPath: "@own-work-type-and-sub-type/api",
  baseQuery,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  refetchOnMountOrArgChange: false,
  keepUnusedDataFor: 60 * 60 * 24,
  tagTypes: ["OwnWorkTypeAndSubTypeRecords"],
  endpoints: (builder) => ({
    getOwnWorkTypeAndSubTypeRecords: builder.query<Array<OwnWorkTypeAndSubTypeRecord>, void>({
      query: () => ({
        url: "/getWorkTypeFilterValues",
        method: "POST",
      }),
      transformResponse: (response: GetOwnWorkTypeAndSubTypeFilterValuesResponseData) => {
        return response.workSubTypes.map((item) => {
          return {
            workTypeId: parseWorkTypeId(item.workTypeId),
            workSubTypeUuid: parseWorkSubTypeUuid(item.workSubTypeUuid),
          };
        });
      },
      providesTags: ["OwnWorkTypeAndSubTypeRecords"],
    }),
  }),
});
